import { StandardDataConstantDimension } from "@/lib/api";

import { Dimension, DimensionValue } from ".";

export class ConstantDimensionValue implements DimensionValue {
  public content: string;

  constructor(content: string) {
    this.content = content;
  }

  get queryStringValue() {
    return this.content;
  }
}

export type ConstantDimensionProps = {
  id: string;
  value: ConstantDimensionValue;
};

export class ConstantDimension implements Dimension {
  private props;

  constructor(props: ConstantDimensionProps) {
    this.props = props;
  }

  static fromData(data: StandardDataConstantDimension) {
    return new ConstantDimension({
      id: data.id,
      value: new ConstantDimensionValue(data.value),
    });
  }

  get id() {
    return this.props.id;
  }
  get value() {
    return this.props.value;
  }
  get values() {
    return [this.value];
  }
  get default() {
    return this.value;
  }

  contains(value: DimensionValue) {
    if (!(value instanceof ConstantDimensionValue)) return false;
    return this.value.content === value.content;
  }

  snap(value: DimensionValue) {
    return this.contains(value) ? value : undefined;
  }

  merge(other: Dimension) {
    if (!(other instanceof ConstantDimension))
      throw new Error("attempted to merge dimensions of different types");
    if (other.id !== this.id)
      throw new Error("attempted to merge dimensions with different IDs");
    if (other.value.content !== this.value.content)
      throw new Error("attempted to merge Constant dimensions with different values");

    return new ConstantDimension(this.props);
  }
}
